// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `:root {
  --upsell-4x-6x-slides-message-z-index: 7999;
  --upsell-4x-6x-slides-message-background: rgba(255, 255, 255, 1);
  --upsell-4x-6x-slides-message-box-shadow: 0px 0px 16px 0px rgba(0, 0, 0, 0.1);
}

.upsell-4x-6x-slides-message {
  width: 375px;
  z-index: var(--upsell-4x-6x-slides-message-z-index);
  background: var(--upsell-4x-6x-slides-message-background);
  top: 30px;
  right: 30px;
  border-radius: 3px;
  box-shadow: var(--upsell-4x-6x-slides-message-box-shadow);
}

.upsell-4x-6x-slides-header {
  margin-top: -10px;
}

.btn-wrapper {
  justify-content: end !important;
  margin-right: 20px !important;
}

.targeted-header {
  font-weight: 700;
  font-size: 18px;
  line-height: 150%;
  letter-spacing: 0.25px;
  margin: -5px 0px 10px 0px;
}

.retail-kad-stats {
  font-weight: 700;
  font-size: 28px;
  line-height: 150%;
  letter-spacing: 0.25px;
  text-align: center;
  color: #e55a00;
}

.retail-upsell-header {
  margin: -27px 0px 10px 0px;
}

.retail-kad-text {
  text-align: justify;
  font-weight: 400;
  font-size: 16px;
  line-height: 150%;
  letter-spacing: 0.25px;
}

.retail-kad-stat-header {
  display: flex;
  flex-direction: column;
  align-items: center;
  text-align: center;
}

.retail-kad-sub-title {
  font-weight: 700;
  font-size: 20px;
  line-height: 150%;
  letter-spacing: 0.25px;
  text-align: center;
  color: #e55a00;
}
`, "",{"version":3,"sources":["webpack://./src/components/targeted-upsell-message/TargetedUpsellMessage.css"],"names":[],"mappings":"AAAA;EACE,2CAA2C;EAC3C,gEAAgE;EAChE,6EAA6E;AAC/E;;AAEA;EACE,YAAY;EACZ,mDAAmD;EACnD,yDAAyD;EACzD,SAAS;EACT,WAAW;EACX,kBAAkB;EAClB,yDAAyD;AAC3D;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,+BAA+B;EAC/B,6BAA6B;AAC/B;;AAEA;EACE,gBAAgB;EAChB,eAAe;EACf,iBAAiB;EACjB,sBAAsB;EACtB,yBAAyB;AAC3B;;AAEA;EACE,gBAAgB;EAChB,eAAe;EACf,iBAAiB;EACjB,sBAAsB;EACtB,kBAAkB;EAClB,cAAc;AAChB;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,mBAAmB;EACnB,gBAAgB;EAChB,eAAe;EACf,iBAAiB;EACjB,sBAAsB;AACxB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;EAChB,eAAe;EACf,iBAAiB;EACjB,sBAAsB;EACtB,kBAAkB;EAClB,cAAc;AAChB","sourcesContent":[":root {\n  --upsell-4x-6x-slides-message-z-index: 7999;\n  --upsell-4x-6x-slides-message-background: rgba(255, 255, 255, 1);\n  --upsell-4x-6x-slides-message-box-shadow: 0px 0px 16px 0px rgba(0, 0, 0, 0.1);\n}\n\n.upsell-4x-6x-slides-message {\n  width: 375px;\n  z-index: var(--upsell-4x-6x-slides-message-z-index);\n  background: var(--upsell-4x-6x-slides-message-background);\n  top: 30px;\n  right: 30px;\n  border-radius: 3px;\n  box-shadow: var(--upsell-4x-6x-slides-message-box-shadow);\n}\n\n.upsell-4x-6x-slides-header {\n  margin-top: -10px;\n}\n\n.btn-wrapper {\n  justify-content: end !important;\n  margin-right: 20px !important;\n}\n\n.targeted-header {\n  font-weight: 700;\n  font-size: 18px;\n  line-height: 150%;\n  letter-spacing: 0.25px;\n  margin: -5px 0px 10px 0px;\n}\n\n.retail-kad-stats {\n  font-weight: 700;\n  font-size: 28px;\n  line-height: 150%;\n  letter-spacing: 0.25px;\n  text-align: center;\n  color: #e55a00;\n}\n\n.retail-upsell-header {\n  margin: -27px 0px 10px 0px;\n}\n\n.retail-kad-text {\n  text-align: justify;\n  font-weight: 400;\n  font-size: 16px;\n  line-height: 150%;\n  letter-spacing: 0.25px;\n}\n\n.retail-kad-stat-header {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  text-align: center;\n}\n\n.retail-kad-sub-title {\n  font-weight: 700;\n  font-size: 20px;\n  line-height: 150%;\n  letter-spacing: 0.25px;\n  text-align: center;\n  color: #e55a00;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
